/** Read/write travelDiarySettings in localStorage (language sync with DB). */

export type StoredSettings = {
  language?: string;
  currency?: string;
  distanceUnit?: string;
  theme?: 'light' | 'dark';
  residenceCountry?: string;
  cars?: unknown[];
  [key: string]: unknown;
};

export function readStoredSettings(): StoredSettings {
  try {
    const raw = localStorage.getItem('travelDiarySettings');
    return raw ? (JSON.parse(raw) as StoredSettings) : {};
  } catch {
    return {};
  }
}

export function writeStoredSettings(patch: StoredSettings): StoredSettings {
  const next = { ...readStoredSettings(), ...patch };
  localStorage.setItem('travelDiarySettings', JSON.stringify(next));
  return next;
}

export function writeLanguageToStorage(language: string): void {
  writeStoredSettings({ language });
}
